import { get } from './http'

const CONTENT_CENTER = {
  // 获取周边列表
  getLifeStudioList: (params) => {
    return get('/operating-platform/campaign/frontend/life/studio/getProductSimpleInfoList', params)
  }
}


export default CONTENT_CENTER